import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { FcPaginatorModule } from '@core/components/fc-paginator/fc-paginator.module';
import { FuseSidebarModule } from '@fuse/components';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { SelectInfoBannerModule } from '../../../../../core/components/select-info-banner/select-info-banner.module';
import { DialogGroupsComponent } from './dialog-groups.component';
import { TabGeneralComponent } from './tabs/general/tab-general.component';
import { LinkLocationsComponent } from './tabs/locations/link-locations/link-locations.component';
import { TabLocationsComponent } from './tabs/locations/tab-locations.component';
import { TabPermissionsComponent } from './tabs/permissions/tab-permissions.component';
import { TabSegmentsComponent } from './tabs/segments/tab-segments.component';
import { LinkUsersComponent } from './tabs/users/link-users/link-users.component';
import { LinkedUsersComponent } from './tabs/users/linked-users/linked-users.component';
import { TabUsersComponent } from './tabs/users/tab-users.component';

@NgModule({
  entryComponents: [
    LinkUsersComponent,
    LinkLocationsComponent,
    DialogGroupsComponent
  ],
  declarations: [
    TabUsersComponent,
    TabLocationsComponent,
    TabGeneralComponent,
    LinkUsersComponent,
    LinkedUsersComponent,
    LinkLocationsComponent,
    DialogGroupsComponent,
    TabPermissionsComponent,
    TabSegmentsComponent
  ],
  exports: [
    DialogGroupsComponent
  ],
  imports: [
    CommonModule,
    DisclaimerModule,
    MatExpansionModule,
    MatTooltipModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatTabsModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    TranslateModule,
    MatListModule,
    FuseSharedModule,
    FuseSidebarModule,
    PipesModule,
    FcPaginatorModule,
    SelectInfoBannerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogGroupsModule {}
